//duplicately named file... but different contents. not everything needs to be in product page store
export async function upvoteReview(ugcId, powerReviewsMerchantId, powerReviewsApiKey) {
  try {
    if (!ugcId || !powerReviewsMerchantId || !powerReviewsApiKey) {
      throw new Error('No review ID or API key provided')
    }
    const res = await fetch(
      `https://writeservices.powerreviews.com/voteugc?apikey=${powerReviewsApiKey}&merchant_id=${powerReviewsMerchantId}&ugc_id=${ugcId}&vote_type=helpful`,
    )
    const data = await res.json()
    return data
  } catch (err) {
    console.error(err)
  }
}

export async function getReviewImages(nextPageUrl, skuBaseNumber, powerReviewsMerchantId, powerReviewsApiKey) {
  try {
    let fetchUrl = null
    if (!nextPageUrl || !nextPageUrl?.includes('image_only=true')) {
      fetchUrl = `https://readservices-b2c.powerreviews.com/m/${powerReviewsMerchantId}/l/en_US/product/${skuBaseNumber}/reviews?apikey=${powerReviewsApiKey}&image_only=true`
    } else {
      fetchUrl = `https://readservices-b2c.powerreviews.com${nextPageUrl}&apikey=${powerReviewsApiKey}`
    }

    const res = await fetch(fetchUrl)
    const data = await res.json()
    return data
  } catch (err) {
    console.error(err)
  }
}
